import { useCurrentAgent } from "hooks/queries/use-current-agent";
import { useMerchant } from "hooks/queries/use-settings-merchant";
import React from "react";
import { Navigate } from "react-router-dom";
import { canManageInboxes } from "util/permissions";

interface ManageInboxesRouteGuardProps {
  redirectTo: string;
  children: React.ReactNode;
}

// Settings → Inboxes needs the dedicated capability; a direct link without
// it lands on `redirectTo` before anything is fetched.
const ManageInboxesRouteGuard = ({
  redirectTo,
  children,
}: ManageInboxesRouteGuardProps) => {
  const { data: currentAgent } = useCurrentAgent();
  const { data: merchant } = useMerchant();

  if (!canManageInboxes(merchant.id, currentAgent)) {
    return <Navigate to={`/${merchant.id}/${redirectTo}`} replace={true} />;
  }

  return <>{children}</>;
};

export default ManageInboxesRouteGuard;
